export const getCitiesCollection = () => [
  {
    value: "Colombo",
    label: "Colombo",

    children: [
      {
        value: "Colombo 01",
        label: "Colombo 01",
      },
      {
        value: "Colombo 02",
        label: "Colombo 02",
      },
      {
        value: "Colombo 03",
        label: "Colombo 03",
      },
      {
        value: "Colombo 04",
        label: "Colombo 04",
      },
      {
        value: "Colombo 05",
        label: "Colombo 05",
      },
      {
        value: "Colombo 06",
        label: "Colombo 06",
      },
      {
        value: "Colombo 07",
        label: "Colombo 07",
      },
      {
        value: "Colombo 08",
        label: "Colombo 08",
      },
      {
        value: "Colombo 08",
        label: "Colombo 08",
      },
      {
        value: "Colombo 08",
        label: "Colombo 08",
      },
      {
        value: "Colombo 09",
        label: "Colombo 09",
      },
      {
        value: "Colombo 10",
        label: "Colombo 10",
      },
      {
        value: "Colombo 11",
        label: "Colombo 11",
      },
      {
        value: "Colombo 12",
        label: "Colombo 12",
      },
      {
        value: "Colombo 13",
        label: "Colombo 13",
      },
      {
        value: "Colombo 14",
        label: "Colombo 14",
      },
      {
        value: "Colombo 15",
        label: "Colombo 15",
      },
      {
        value: "Angoda ",
        label: "Angoda ",
      },
      {
        value: "Athurugiriya",
        label: "Athurugiriya",
      },
      {
        value: "Awissawella",
        label: "Awissawella",
      },
      {
        value: "Battaramulla",
        label: "Battaramulla",
      },
      {
        value: "Boralesgamuwa",
        label: "Boralesgamuwa",
      },
      {
        value: "Dehiwala",
        label: "Dehiwala",
      },
      {
        value: "Hanwella",
        label: "Hanwella",
      },
      {
        value: "Homagama ",
        label: "Homagama ",
      },
      {
        value: "Kaduwela",
        label: "Kaduwela",
      },
      {
        value: "Kesbewa",
        label: "Kesbewa",
      },
      {
        value: "Kohuwala",
        label: "Kohuwala",
      },
      {
        value: "Kolonnawa",
        label: "Kolonnawa",
      },
      {
        value: "Kottawa",
        label: "Kottawa",
      },
      {
        value: "Kotte",
        label: "Kotte",
      },
      {
        value: "Maharagama",
        label: "Maharagama",
      },
      {
        value: "Malabe",
        label: "Malabe",
      },
      {
        value: "Moratuwa",
        label: "Moratuwa",
      },
      {
        value: "Mount Lavinia",
        label: "Mount Lavinia",
      },
      {
        value: "Nawala",
        label: "Nawala",
      },
      {
        value: "Nugegoda",
        label: "Nugegoda",
      },
      {
        value: "Padukka",
        label: "Padukka",
      },
      {
        value: "Pannipitiya",
        label: "Pannipitiya",
      },
      {
        value: "Piliyandala",
        label: "Piliyandala",
      },
      {
        value: "Rajagiriya",
        label: "Rajagiriya",
      },
      {
        value: "Rathmalana",
        label: "Rathmalana",
      },
      {
        value: "Thalawathugoda",
        label: "Thalawathugoda",
      },
      {
        value: "Wellampitiya",
        label: "Wellampitiya",
      },
    ],
  },

  {
    value: "Kandy",
    label: "Kandy",

    children: [
      {
        value: "Kandy",
        label: "Kandy",
      },
      {
        value: "Katugastota",
        label: "Katugastota",
      },
      {
        value: "Peradeniya",
        label: "Peradeniya",
      },
      {
        value: "Gampola",
        label: "Gampola",
      },
      {
        value: "Kadugannawa",
        label: "Kadugannawa",
      },
      {
        value: "Kundasale",
        label: "Kundasale",
      },
      {
        value: "Akurana",
        label: "Akurana",
      },
      {
        value: "Gelioya",
        label: "Gelioya",
      },
      {
        value: "Nawalapitiya",
        label: "Nawalapitiya",
      },
      {
        value: "Pilimathalawa",
        label: "Pilimathalawa",
      },
    ],
  },

  {
    value: "Kurunegala",
    label: "Kurunegala",

    children: [
      {
        value: "Kurunegala",
        label: "Kurunegala",
      },
      {
        value: "Kuliyapitiya",
        label: "Kuliyapitiya",
      },
      {
        value: "Pannala",
        label: "Pannala",
      },
      {
        value: "Narammala",
        label: "Narammala",
      },
      {
        value: "Wariyapola",
        label: "Wariyapola",
      },
      {
        value: "Alawwa",
        label: "Alawwa",
      },
      {
        value: "Bingiriya",
        label: "Bingiriya",
      },
      {
        value: "Galgamuwa",
        label: "Galgamuwa",
      },
      {
        value: "Giriulla",
        label: "Giriulla",
      },
      {
        value: "Hettipola",
        label: "Hettipola",
      },
      {
        value: "Ibbagamuwa",
        label: "Ibbagamuwa",
      },
      {
        value: "Mawathagama",
        label: "Mawathagama",
      },
      {
        value: "Nikaweratiya",
        label: "Nikaweratiya",
      },
      {
        value: "Polgahawela",
        label: "Polgahawela",
      },
    ],
  },

  {
    value: "Ratnapura",
    label: "Ratnapura",

    children: [
      {
        value: "Ratnapura",
        label: "Ratnapura",
      },
      {
        value: "Embilipitiya",
        label: "Embilipitiya",
      },
      {
        value: "Balangoda",
        label: "Balangoda",
      },
      {
        value: "Pelmadulla",
        label: "Pelmadulla",
      },
      {
        value: "Eheliyagoda",
        label: "Eheliyagoda",
      },
      {
        value: "Kuruwita",
        label: "Kuruwita",
      },
      {
        value: "Godakawela",
        label: "Godakawela",
      },
      {
        value: "Udawalawa",
        label: "Udawalawa",
      },
    ],
  },

  {
    value: "Galle",
    label: "Galle",

    children: [
      {
        value: "Galle",
        label: "Galle",
      },
      {
        value: "Ambalangoda",
        label: "Ambalangoda",
      },
      {
        value: "Elpitiya",
        label: "Elpitiya",
      },
      {
        value: "Hikkaduwa",
        label: "Hikkaduwa",
      },
      {
        value: "Baddegama",
        label: "Baddegama",
      },
      {
        value: "Ahangama",
        label: "Ahangama",
      },
      {
        value: "Batapola",
        label: "Batapola",
      },
      {
        value: "Benthota",
        label: "Benthota",
      },
      {
        value: "Katapitiya",
        label: "Katapitiya",
      },
    ],
  },

  {
    value: "Ampara",
    label: "Ampara",

    children: [
      {
        value: "Ampara",
        label: "Ampara",
      },
      {
        value: "Akkarepattu",
        label: "Akkarepattu",
      },
      {
        value: "Kalmunai",
        label: "Kalmunai",
      },
      {
        value: "Sainthamaruthu",
        label: "Sainthamaruthu",
      },
    ],
  },

  {
    value: "Anuradhapura",
    label: "Anuradhapura",

    children: [
      {
        value: "Anuradhapura",
        label: "Anuradhapura",
      },
      {
        value: "Kekirawa",
        label: "Kekirawa",
      },
      {
        value: "Medawachchiya",
        label: "Medawachchiya",
      },
      {
        value: "Eppawala",
        label: "Eppawala",
      },
      {
        value: "Tambuttegama",
        label: "Tambuttegama",
      },
      {
        value: "Galenbidunuwewa",
        label: "Galenbidunuwewa",
      },
      {
        value: "Galnewa",
        label: "Galnewa",
      },
      {
        value: "Habarana",
        label: "Habarana",
      },
      {
        value: "Mihinthale",
        label: "Mihinthale",
      },
      {
        value: "Nochchiyagama",
        label: "Nochchiyagama",
      },
      {
        value: "Thalawa",
        label: "Thalawa",
      },
    ],
  },

  {
    value: "Badulla",
    label: "Badulla",

    children: [
      {
        value: "Badulla",
        label: "Badulla",
      },
      {
        value: "Bandarawela",
        label: "Bandarawela",
      },
      {
        value: "Welimada",
        label: "Welimada",
      },
      {
        value: "Mahiyanganaya",
        label: "Mahiyanganaya",
      },
      {
        value: "Ella",
        label: "Ella",
      },
      {
        value: "Haputale",
        label: "Haputale",
      },
    ],
  },

  {
    value: "Batticaloa",
    label: "Batticaloa",

    children: [
      {
        value: "Batticaloa",
        label: "Batticaloa",
      },
    ],
  },

  {
    value: "Gampaha",
    label: "Gampaha",

    children: [
      {
        value: "Gampaha",
        label: "Gampaha",
      },
      {
        value: "Negombo",
        label: "Negombo",
      },
      {
        value: "Kelaniya",
        label: "Kelaniya",
      },
      {
        value: "Kiribathgoda",
        label: "Kiribathgoda",
      },
      {
        value: "Kadawatha",
        label: "Kadawatha",
      },
      {
        value: "Delgoda",
        label: "Delgoda",
      },
      {
        value: "Divulapitiya",
        label: "Divulapitiya",
      },
      {
        value: "Ganemulla",
        label: "Ganemulla",
      },
      {
        value: "Ja-Ela",
        label: "Ja-Ela",
      },
      {
        value: "Kandana",
        label: "Kandana",
      },
      {
        value: "Katunayake",
        label: "Katunayake",
      },
      {
        value: "Minuwangoda",
        label: "Minuwangoda",
      },
      {
        value: "Mirigama",
        label: "Mirigama",
      },
      {
        value: "Nittambuwa",
        label: "Nittambuwa",
      },
      {
        value: "Ragama",
        label: "Ragama",
      },
      {
        value: "Veyangoda",
        label: "Veyangoda",
      },
      {
        value: "Wattala",
        label: "Wattala",
      },
    ],
  },

  {
    value: "Hambantota",
    label: "Hambantota",

    children: [
      {
        value: "Hambantota",
        label: "Hambantota",
      },
      {
        value: "Tangalla",
        label: "Tangalla",
      },
      {
        value: "Beliatta",
        label: "Beliatta",
      },
      {
        value: "Ambalantota",
        label: "Ambalantota",
      },
      {
        value: "Tissamaharama",
        label: "Tissamaharama",
      },
    ],
  },

  {
    value: "Jaffna",
    label: "Jaffna",

    children: [
      {
        value: "Jaffna",
        label: "Jaffna",
      },
      {
        value: "Nallur",
        label: "Nallur",
      },
      {
        value: "Chavakachcheri",
        label: "Chavakachcheri",
      },
    ],
  },

  {
    value: "Kalutara",
    label: "Kalutara",

    children: [
      {
        value: "Kalutara",
        label: "Kalutara",
      },
      {
        value: "Horana",
        label: "Horana",
      },
      {
        value: "Panadura",
        label: "Panadura",
      },
      {
        value: "Bandaragama",
        label: "Bandaragama",
      },
      {
        value: "Dharga Town",
        label: "Dharga Town",
      },
      {
        value: "Matugama",
        label: "Matugama",
      },
      {
        value: "Aluthgama",
        label: "Aluthgama",
      },
      {
        value: "Beruwala",
        label: "Beruwala",
      },
      {
        value: "Ingiriya",
        label: "Ingiriya",
      },
      {
        value: "Wadduwa",
        label: "Wadduwa",
      },
    ],
  },

  {
    value: "Kegalle",
    label: "Kegalle",

    children: [
      {
        value: "Kegalle",
        label: "Kegalle",
      },
      {
        value: "Aranayaka",
        label: "Aranayaka",
      },
      {
        value: "Mawanella",
        label: "Mawanella",
      },
      {
        value: "Warakapola",
        label: "Warakapola",
      },
      {
        value: "Rambukkana",
        label: "Rambukkana",
      },
      {
        value: "Galigamuwa",
        label: "Galigamuwa",
      },
    ],
  },

  {
    value: "Kilinochchi",
    label: "Kilinochchi",

    children: [
      {
        value: "All of Kilinochchi",
        label: "All of Kilinochchi",
      },
      {
        value: "Kilinochchi",
        label: "Kilinochchi",
      },
    ],
  },

  {
    value: "Mannar",
    label: "Mannar",

    children: [
      {
        value: "Mannar",
        label: "Mannar",
      },
    ],
  },

  {
    value: "Matale",
    label: "Matale",

    children: [
      {
        value: "Matale",
        label: "Matale",
      },
      {
        value: "Dambulla",
        label: "Dambulla",
      },
      {
        value: "Galewela",
        label: "Galewela",
      },
      {
        value: "Ukuwela",
        label: "Ukuwela",
      },
      {
        value: "Sigiriya",
        label: "Sigiriya",
      },
      {
        value: "Palapathwela",
        label: "Palapathwela",
      },
      {
        value: "Rattota",
        label: "Rattota",
      },
      {
        value: "Yatawatta",
        label: "Yatawatta",
      },
    ],
  },

  {
    value: "Matara",
    label: "Matara",

    children: [
      {
        value: "Matara",
        label: "Matara",
      },
      {
        value: "Akuressa",
        label: "Akuressa",
      },
      {
        value: "Weligama",
        label: "Weligama",
      },
      {
        value: "Dikwella",
        label: "Dikwella",
      },
      {
        value: "Hakmana",
        label: "Hakmana",
      },
      {
        value: "Deniyaya",
        label: "Deniyaya",
      },
      {
        value: "Kamburugamuwa",
        label: "Kamburugamuwa",
      },
      {
        value: "Kamburupitiya",
        label: "Kamburupitiya",
      },
      {
        value: "Mirissa",
        label: "Mirissa",
      },
      {
        value: "Morawaka",
        label: "Morawaka",
      },
      {
        value: "Pitabaddara",
        label: "Pitabaddara",
      },
    ],
  },

  {
    value: "Monaragala",
    label: "Monaragala",

    children: [
      {
        value: "Monaragala",
        label: "Monaragala",
      },
      {
        value: "Wellawaya",
        label: "Wellawaya",
      },
      {
        value: "Bibile",
        label: "Bibile",
      },
      {
        value: "Kataragama",
        label: "Kataragama",
      },
      {
        value: "Buttala",
        label: "Buttala",
      },
    ],
  },

  {
    value: "Mullativu",
    label: "Mullativu",

    children: [
      {
        value: "Mullativu",
        label: "Mullativu",
      },
    ],
  },

  {
    value: "Nuwara Eliya",
    label: "Nuwara Eliya",

    children: [
      {
        value: "Nuwara Eliya",
        label: "Nuwara Eliya",
      },
      {
        value: "Hatton",
        label: "Hatton",
      },
      {
        value: "Ginigathena",
        label: "Ginigathena",
      },
      {
        value: "Thalawakele",
        label: "Thalawakele",
      },
      {
        value: "Maskeliya",
        label: "Maskeliya",
      },
    ],
  },

  {
    value: "Polonnaruwa",
    label: "Polonnaruwa",

    children: [
      {
        value: "Polonnaruwa",
        label: "Polonnaruwa",
      },
      {
        value: "Kaduruwela",
        label: "Kaduruwela",
      },
      {
        value: "Hingurakgoda",
        label: "Hingurakgoda",
      },
      {
        value: "Medirigiriya",
        label: "Medirigiriya",
      },
    ],
  },

  {
    value: "Puttalam",
    label: "Puttalam",

    children: [
      {
        value: "Puttalam",
        label: "Puttalam",
      },
      {
        value: "Chilaw",
        label: "Chilaw",
      },
      {
        value: "Wennappuwa",
        label: "Wennappuwa",
      },
      {
        value: "Dankotuwa",
        label: "Dankotuwa",
      },
      {
        value: "Nattandiya",
        label: "Nattandiya",
      },
      {
        value: "Marawila",
        label: "Marawila",
      },
    ],
  },

  {
    value: "Trincomalee",
    label: "Trincomalee",

    children: [
      {
        value: "Trincomalee",
        label: "Trincomalee",
      },
      {
        value: "Kinniya",
        label: "Kinniya",
      },
    ],
  },

  {
    value: "Vavuniya",
    label: "Vavuniya",

    children: [
      {
        value: "Vavuniya",
        label: "Vavuniya",
      },
    ],
  },
];

export const getCityCoordinates = () => [
  {
    value: [6.9271, 79.8612],
    label: "All of Colombo",
  },
  {
    value: [6.9271, 79.8612],
    label: "Colombo 01",
  },
  {
    value: [6.9222, 79.8549],
    label: "Colombo 02",
  },
  {
    value: [6.901, 79.8549],
    label: "Colombo 03",
  },
  {
    value: [6.8865, 79.8563],
    label: "Colombo 04",
  },
  {
    value: [6.8908, 79.8717],
    label: "Colombo 05",
  },
  {
    value: [6.8747, 79.8605],
    label: "Colombo 06",
  },
  {
    value: [6.9117, 79.8646],
    label: "Colombo 07",
  },
  {
    value: [6.9122, 79.8829],
    label: "Colombo 08",
  },
  {
    value: [6.9122, 79.8829],
    label: "Colombo 08",
  },
  {
    value: [6.9122, 79.8829],
    label: "Colombo 08",
  },
  {
    value: [6.9332, 79.8773],
    label: "Colombo 09",
  },
  {
    value: [6.9224, 79.8661],
    label: "Colombo 10",
  },
  {
    value: [6.9367, 79.8535],
    label: "Colombo 11",
  },
  {
    value: [6.9382, 79.8605],
    label: "Colombo 12",
  },
  {
    value: [6.9488, 79.8605],
    label: "Colombo 13",
  },
  {
    value: [6.9511, 79.8741],
    label: "Colombo 14",
  },
  {
    value: [6.9702, 79.8717],
    label: "Colombo 15",
  },
  {
    value: [6.9367, 79.927],
    label: "Angoda ",
  },
  {
    value: [6.8723, 80.0004],
    label: "Athurugiriya",
  },
  {
    value: [6.9543, 80.2046],
    label: "Awissawella",
  },
  {
    value: [6.898, 79.9223],
    label: "Battaramulla",
  },
  {
    value: [6.841, 79.9017],
    label: "Boralesgamuwa",
  },
  {
    value: [6.8301, 79.8801],
    label: "Dehiwala",
  },
  {
    value: [6.8978, 80.0814],
    label: "Hanwella",
  },
  {
    value: [6.8433, 80.0032],
    label: "Homagama ",
  },
  {
    value: [6.9291, 79.9828],
    label: "Kaduwela",
  },
  {
    value: [6.7787, 79.9473],
    label: "Kesbewa",
  },
  {
    value: [6.8625, 79.8855],
    label: "Kohuwala",
  },
  {
    value: [6.9284, 79.895],
    label: "Kolonnawa",
  },
  {
    value: [6.8412, 79.9654],
    label: "Kottawa",
  },
  {
    value: [6.8868, 79.9187],
    label: "Kotte",
  },
  {
    value: [6.8511, 79.9212],
    label: "Maharagama",
  },
  {
    value: [6.9061, 79.9696],
    label: "Malabe",
  },
  {
    value: [6.7881, 79.8913],
    label: "Moratuwa",
  },
  {
    value: [6.8301, 79.8801],
    label: "Mount Lavinia",
  },
  {
    value: [6.895, 79.924],
    label: "Nawala",
  },
  {
    value: [6.8649, 79.8997],
    label: "Nugegoda",
  },
  {
    value: [6.8454, 80.1038],
    label: "Padukka",
  },
  {
    value: [6.8464, 79.9484],
    label: "Pannipitiya",
  },
  {
    value: [6.8018, 79.9227],
    label: "Piliyandala",
  },
  {
    value: [6.9094, 79.8943],
    label: "Rajagiriya",
  },
  {
    value: [6.8195, 79.8801],
    label: "Rathmalana",
  },
  {
    value: [6.8759, 79.9392],
    label: "Thalawathugoda",
  },
  {
    value: [6.9424, 79.9046],
    label: "Wellampitiya",
  },
  {
    value: [7.2906, 80.6337],
    label: "All of Kandy",
  },
  {
    value: [7.2906, 80.6337],
    label: "Kandy",
  },
  {
    value: [7.336, 80.6214],
    label: "Katugastota",
  },
  {
    value: [7.2699, 80.5938],
    label: "Peradeniya",
  },
  {
    value: [7.1268, 80.5647],
    label: "Gampola",
  },
  {
    value: [7.255, 80.5188],
    label: "Kadugannawa",
  },
  {
    value: [7.3096, 80.7104],
    label: "Kundasale",
  },
  {
    value: [7.369, 80.6133],
    label: "Akurana",
  },
  {
    value: [7.2153, 80.598],
    label: "Gelioya",
  },
  {
    value: [7.0447, 80.5161],
    label: "Nawalapitiya",
  },
  {
    value: [7.2663, 80.5522],
    label: "Pilimathalawa",
  },
  {
    value: [7.084, 80.0098],
    label: "All of Gampaha",
  },
  {
    value: [7.084, 80.0098],
    label: "Gampaha",
  },
  {
    value: [7.2008, 79.8737],
    label: "Negombo",
  },
  {
    value: [6.9518, 79.9133],
    label: "Kelaniya",
  },
  {
    value: [6.9778, 79.9272],
    label: "Kiribathgoda",
  },
  {
    value: [7.0047, 79.9542],
    label: "Kadawatha",
  },
  {
    value: [6.9879, 80.0158],
    label: "Delgoda",
  },
  {
    value: [7.2303, 80.0165],
    label: "Divulapitiya",
  },
  {
    value: [7.0624, 79.9668],
    label: "Ganemulla",
  },
  {
    value: [7.0668, 79.9041],
    label: "Ja-Ela",
  },
  {
    value: [7.0478, 79.897],
    label: "Kandana",
  },
  {
    value: [7.1725, 79.8853],
    label: "Katunayake",
  },
  {
    value: [7.1842, 79.95],
    label: "Minuwangoda",
  },
  {
    value: [7.2427, 80.127],
    label: "Mirigama",
  },
  {
    value: [7.1424, 80.1038],
    label: "Nittambuwa",
  },
  {
    value: [7.028, 79.923],
    label: "Ragama",
  },
  {
    value: [7.1541, 80.0594],
    label: "Veyangoda",
  },
  {
    value: [6.9907, 79.8932],
    label: "Wattala",
  },
  {
    value: [6.0535, 80.221],
    label: "All of Galle",
  },
  {
    value: [6.0535, 80.221],
    label: "Galle",
  },
  {
    value: [6.2442, 80.0591],
    label: "Ambalangoda",
  },
  {
    value: [6.288, 80.1596],
    label: "Elpitiya",
  },
  {
    value: [6.1395, 80.1063],
    label: "Hikkaduwa",
  },
  {
    value: [6.1688, 80.1794],
    label: "Baddegama",
  },
  {
    value: [5.974, 80.3622],
    label: "Ahangama",
  },
  {
    value: [6.2242, 80.1138],
    label: "Batapola",
  },
  {
    value: [6.4189, 80.006],
    label: "Benthota",
  },
  {
    value: [6.0706, 80.2252],
    label: "Karapitiya",
  },
  {
    value: [7.3018, 81.6747],
    label: "All of Ampara",
  },
  {
    value: [7.3018, 81.6747],
    label: "Ampara",
  },
  {
    value: [7.2194, 81.8498],
    label: "Akkaraipattu",
  },
  {
    value: [7.4144, 81.8306],
    label: "Kalmunai",
  },
  {
    value: [7.393, 81.8361],
    label: "Sainthamaruthu",
  },
  {
    value: [8.3114, 80.4037],
    label: "All of Anuradhapura",
  },
  {
    value: [8.3114, 80.4037],
    label: "Anuradhapura",
  },
  {
    value: [8.0421, 80.5938],
    label: "Kekirawa",
  },
  {
    value: [8.5375, 80.491],
    label: "Medawachchiya",
  },
  {
    value: [8.1441, 80.4119],
    label: "Eppawala",
  },
  {
    value: [8.154, 80.3046],
    label: "Tambuttegama",
  },
  {
    value: [8.2921, 80.7173],
    label: "Galenbidunuwewa",
  },
  {
    value: [8.0369, 80.4725],
    label: "Galnewa",
  },
  {
    value: [8.0322, 80.7519],
    label: "Habarana",
  },
  {
    value: [8.35, 80.5],
    label: "Mihinthale",
  },
  {
    value: [8.2926, 80.2266],
    label: "Nochchiyagama",
  },
  {
    value: [8.149, 80.4089],
    label: "Thalawa",
  },
  {
    value: [6.9934, 81.055],
    label: "All of Badulla",
  },
  {
    value: [6.9934, 81.055],
    label: "Badulla",
  },
  {
    value: [6.8259, 80.9982],
    label: "Bandarawela",
  },
  {
    value: [6.9019, 80.9079],
    label: "Welimada",
  },
  {
    value: [7.3316, 81.0037],
    label: "Mahiyanganaya",
  },
  {
    value: [6.8667, 81.0466],
    label: "Ella",
  },
  {
    value: [6.7654, 80.9526],
    label: "Haputale",
  },
  {
    value: [7.731, 81.6747],
    label: "All of Batticaloa",
  },
  {
    value: [7.731, 81.6747],
    label: "Batticaloa",
  },
  {
    value: [6.1429, 81.1212],
    label: "All of Hambantota",
  },
  {
    value: [6.1429, 81.1212],
    label: "Hambantota",
  },
  {
    value: [6.0243, 80.7941],
    label: "Tangalle",
  },
  {
    value: [6.0482, 80.7339],
    label: "Beliatta",
  },
  {
    value: [6.1226, 81.0238],
    label: "Ambalantota",
  },
  {
    value: [6.2792, 81.2877],
    label: "Tissamaharama",
  },
  {
    value: [9.6615, 80.0255],
    label: "All of Jaffna",
  },
  {
    value: [9.6615, 80.0255],
    label: "Jaffna",
  },
  {
    value: [9.4503, 80.2781],
    label: "Nallur",
  },
  {
    value: [9.6665, 80.1321],
    label: "Chavakachcheri",
  },
  {
    value: [6.5854, 79.9607],
    label: "All of Kalutara",
  },
  {
    value: [6.5854, 79.9607],
    label: "Kalutara",
  },
  {
    value: [6.723, 80.0647],
    label: "Horana",
  },
  {
    value: [6.7106, 79.9074],
    label: "Panadura",
  },
  {
    value: [6.7144, 79.9891],
    label: "Bandaragama",
  },
  {
    value: [6.4447, 80.0169],
    label: "Dharga Town",
  },
  {
    value: [6.5219, 80.1137],
    label: "Matugama",
  },
  {
    value: [6.4346, 80.0004],
    label: "Aluthgama",
  },
  {
    value: [6.4738, 79.992],
    label: "Beruwala",
  },
  {
    value: [6.7404, 80.1625],
    label: "Ingiriya",
  },
  {
    value: [6.6363, 79.9528],
    label: "Wadduwa",
  },
  {
    value: [7.2513, 80.3464],
    label: "All of Kegalle",
  },
  {
    value: [7.2513, 80.3464],
    label: "Kegalle",
  },
  {
    value: [7.1497, 80.465],
    label: "Aranayaka",
  },
  {
    value: [7.2481, 80.4466],
    label: "Mawanella",
  },
  {
    value: [7.2268, 80.1959],
    label: "Warakapola",
  },
  {
    value: [7.3135, 80.3881],
    label: "Rambukkana",
  },
  {
    value: [7.2359, 80.3116],
    label: "Galigamuwa",
  },
  {
    value: [9.3803, 80.377],
    label: "All of Kilinochchi",
  },
  {
    value: [9.3803, 80.377],
    label: "Kilinochchi",
  },
  {
    value: [7.4818, 80.3609],
    label: "All of Kurunegala",
  },
  {
    value: [7.4818, 80.3609],
    label: "Kurunegala",
  },
  {
    value: [7.4721, 80.0446],
    label: "Kuliyapitiya",
  },
  {
    value: [7.3295, 80.0228],
    label: "Pannala",
  },
  {
    value: [7.4325, 80.2154],
    label: "Narammala",
  },
  {
    value: [7.6239, 80.2433],
    label: "Wariyapola",
  },
  {
    value: [7.2954, 80.2366],
    label: "Alawwa",
  },
  {
    value: [7.5982, 79.9372],
    label: "Bingiriya",
  },
  {
    value: [7.9865, 80.2879],
    label: "Galgamuwa",
  },
  {
    value: [7.3318, 80.1233],
    label: "Giriulla",
  },
  {
    value: [7.5331, 80.9152],
    label: "Hettipola",
  },
  {
    value: [7.5554, 80.4564],
    label: "Ibbagamuwa",
  },
  {
    value: [7.4322, 80.4438],
    label: "Mawathagama",
  },
  {
    value: [7.7464, 80.1317],
    label: "Nikaweratiya",
  },
  {
    value: [7.3275, 80.2935],
    label: "Polgahawela",
  },
  {
    value: [8.981, 79.9044],
    label: "All of Mannar",
  },
  {
    value: [8.981, 79.9044],
    label: "Mannar",
  },
  {
    value: [7.4675, 80.6234],
    label: "All of Matale",
  },
  {
    value: [7.4675, 80.6234],
    label: "Matale",
  },
  {
    value: [7.8742, 80.6511],
    label: "Dambulla",
  },
  {
    value: [7.7565, 80.5772],
    label: "Galewela",
  },
  {
    value: [7.4235, 80.6306],
    label: "Ukuwela",
  },
  {
    value: [7.9512, 80.7448],
    label: "Sigiriya",
  },
  {
    value: [7.5377, 80.6271],
    label: "Palapathwela",
  },
  {
    value: [7.5173, 80.6715],
    label: "Rattota",
  },
  {
    value: [7.5635, 80.5877],
    label: "Yatawatta",
  },
  {
    value: [5.9549, 80.555],
    label: "All of Matara",
  },
  {
    value: [5.9549, 80.555],
    label: "Matara",
  },
  {
    value: [6.1001, 80.476],
    label: "Akuressa",
  },
  {
    value: [5.9774, 80.4288],
    label: "Weligama",
  },
  {
    value: [5.9717, 80.6951],
    label: "Dikwella",
  },
  {
    value: [6.0796, 80.6577],
    label: "Hakmana",
  },
  {
    value: [6.3425, 80.5597],
    label: "Deniyaya",
  },
  {
    value: [5.9486, 80.4938],
    label: "Kamburugamuwa",
  },
  {
    value: [6.0779, 80.5633],
    label: "Kamburupitiya",
  },
  {
    value: [5.9483, 80.4716],
    label: "Mirissa",
  },
  {
    value: [6.2653, 80.491],
    label: "Morawaka",
  },
  {
    value: [6.2071, 80.4632],
    label: "Pitabaddara",
  },
  {
    value: [6.8728, 81.3507],
    label: "All of Monaragala",
  },
  {
    value: [6.8728, 81.3507],
    label: "Monaragala",
  },
  {
    value: [6.7377, 81.1031],
    label: "Wellawaya",
  },
  {
    value: [7.1624, 81.2216],
    label: "Bibile",
  },
  {
    value: [6.4135, 81.3326],
    label: "Kataragama",
  },
  {
    value: [6.7589, 81.2491],
    label: "Buttala",
  },
  {
    value: [9.2671, 80.8142],
    label: "All of Mullativu",
  },
  {
    value: [9.2671, 80.8142],
    label: "Mullativu",
  },
  {
    value: [6.9497, 80.7891],
    label: "All of Nuwara Eliya",
  },
  {
    value: [6.9497, 80.7891],
    label: "Nuwara Eliya",
  },
  {
    value: [6.9003, 80.5966],
    label: "Hatton",
  },
  {
    value: [6.9893, 80.4927],
    label: "Ginigathhena",
  },
  {
    value: [6.9388, 80.6632],
    label: "Thalawakele",
  },
  {
    value: [6.8329, 80.5709],
    label: "Maskeliya",
  },
  {
    value: [7.9403, 81.0188],
    label: "All of Polonnaruwa",
  },
  {
    value: [7.9403, 81.0188],
    label: "Polonnaruwa",
  },
  {
    value: [7.9308, 81.0451],
    label: "Kaduruwela",
  },
  {
    value: [8.0416, 80.9532],
    label: "Hingurakgoda",
  },
  {
    value: [8.1505, 80.979],
    label: "Medirigiriya",
  },
  {
    value: [8.0408, 79.8394],
    label: "All of Puttalam",
  },
  {
    value: [8.0408, 79.8394],
    label: "Puttalam",
  },
  {
    value: [7.562, 79.8017],
    label: "Chilaw",
  },
  {
    value: [7.3493, 79.8353],
    label: "Wennappuwa",
  },
  {
    value: [7.2975, 79.8822],
    label: "Dankotuwa",
  },
  {
    value: [7.4125, 79.8591],
    label: "Nattandiya",
  },
  {
    value: [7.4239, 79.8353],
    label: "Marawila",
  },
  {
    value: [6.7056, 80.3847],
    label: "All of Ratnapura",
  },
  {
    value: [6.7056, 80.3847],
    label: "Ratnapura",
  },
  {
    value: [6.3162, 80.8433],
    label: "Embilipitiya",
  },
  {
    value: [6.6669, 80.7048],
    label: "Balangoda",
  },
  {
    value: [6.6345, 80.53],
    label: "Pelmadulla",
  },
  {
    value: [6.8486, 80.26],
    label: "Eheliyagoda",
  },
  {
    value: [6.8218, 80.3615],
    label: "Kuruwita",
  },
  {
    value: [6.5049, 80.6521],
    label: "Godakawela",
  },
  {
    value: [6.4185, 80.8239],
    label: "Udawalawa",
  },
  {
    value: [8.5874, 81.2152],
    label: "All of Trincomalee",
  },
  {
    value: [8.5874, 81.2152],
    label: "Trincomalee",
  },
  {
    value: [8.5025, 81.1804],
    label: "Kinniya",
  },
  {
    value: [8.7542, 80.4982],
    label: "All of Vavuniya",
  },
  {
    value: [8.7542, 80.4982],
    label: "Vavuniya",
  },
];
